import { useDebouncedValue } from "@mantine/hooks"
import CustomAlert from "components/Atoms/CustomAlert"
import CustomButton from "components/Atoms/CustomButton"
import CustomMarker from "components/Organisms/map/CustomMarker"
import StickyPolygon from "components/Templates/StickyPolygon"
import React, { useState } from "react"
import { jsonToGis } from "utils/map.utils"
import useDCStore from "./dc.store"
const AreaPolygon = ({
  coordinates,
  index,
  allDcVertices,
  disabled,
  isSticky,
}) => {
  const [alertVisible, setAlert] = useState(false)
  const [overlayVisible, setOverlay] = useState(false)
  const [debouncedOverlayVisible] = useDebouncedValue(overlayVisible, 1750)
  const bounds = new window.google.maps.LatLngBounds()
  coordinates && coordinates.forEach(co => bounds.extend(co))
  const center = bounds?.getCenter()?.toJSON()

  const { onRemove, color, onChange } = useDCStore(store => ({
    onRemove: store.removeListItem,
    color: store.state.basicDetails.colorCode,
    onChange: store.setData("basicDetails"),
  }))
  return (
    <>
      <StickyPolygon
        disableStickyPoints={!isSticky}
        disabled={disabled}
        boundaryPoints={allDcVertices}
        onMouseOver={() => setOverlay(true)}
        onMouseOut={() => setOverlay(false)}
        options={{
          fillColor: color?.id,
          strokeColor: color?.id,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillOpacity: 0.1,
        }}
        onChange={coords => {
          onChange(`geometry.coordinates.${index}.0`, jsonToGis(coords))
        }}
        path={coordinates}
      />
      {debouncedOverlayVisible && (
        <CustomMarker position={center}>
          <CustomButton
            icon="trash"
            onClick={e => {
              setAlert(true)
            }}
          />
        </CustomMarker>
      )}
      <CustomAlert
        intent="danger"
        icon="warning-sign"
        light
        cancelButtonText="Cancel"
        onClose={confirm => {
          if (confirm) {
            onRemove("basicDetails.geometry.coordinates", index)
          }
          setAlert(false)
        }}
        confirmButtonText="Delete"
        isOpen={alertVisible}
      >
        <p>Are you sure you want to delete this polygon ?</p>
      </CustomAlert>
    </>
  )
}

export default AreaPolygon
